import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { TimeBasedWorkProposition } from '../models/time-based-work-proposition.model';
import { CreateTimeBasedWorkPropositionRequest } from '../models/requests/create-time-based-work-proposition-request';
import { UpdateTimeBasedWorkPropositionRequest } from '../models/requests/update-time-based-work-proposition-request';

@Injectable({
  providedIn: 'root',
})
export class TimeBasedWorkPropositionService {
  constructor(private apiService: ApiService) {}

  public getByRuleId(
    ruleUniqueId: string
  ): Observable<TimeBasedWorkProposition[]> {
    const options = {
      queryParams: {
        ruleUniqueId: ruleUniqueId.toString(),
      },
    };
    return this.apiService.get<TimeBasedWorkProposition[]>(
      `/TimeBasedWorkProposition/GetByRuleUid`,
      options
    );
  }

  public DeleteMultipleTimeBasedWorkPropositions(
    uids: string[]
  ): Observable<any> {
    
    return this.apiService.post(
      `/TimeBasedWorkProposition/DeleteMultiple`,
      uids
    );
  }

  public UpdateMultipleTimeBasedWorkPropositions(
    payload: UpdateTimeBasedWorkPropositionRequest[]
  ): Observable<TimeBasedWorkProposition[]> {
    return this.apiService.put<TimeBasedWorkProposition[]>(
      `/TimeBasedWorkProposition/UpdateMultiple`,
      payload
    );
  }

  public CreateMultipleTimeBasedWorkPropositions(
    payload: CreateTimeBasedWorkPropositionRequest[]
  ): Observable<TimeBasedWorkProposition[]> {
    return this.apiService.post<TimeBasedWorkProposition[]>(
      `/TimeBasedWorkProposition/CreateMultiple`,
      payload
    );
  }
}
